import { requestUrl, oauthRequestUrl } from "@/config/config";
// 套餐查询
export const getPackageList = `${requestUrl}/manage/menu/list`;
// 套餐新增
export const addPackage = `${requestUrl}/manage/menu/add`;
// 套餐删除
export const delPackage = (id) => `${requestUrl}/manage/menu/delete?id=${id}`;
// 套餐编辑
export const editPackage = `${requestUrl}/manage/menu/edit`;
// 套餐购买
export const myMenuList = `${requestUrl}/manage/myMenu/web/list`;
// 充值记录
// export const rechargeRecord = `${requestUrl}/manage/rechargeRecord/list`
export const rechargeRecord = `${requestUrl}/paycenter/manage/list`;
// 国版币消费
export const currencyList = `${requestUrl}/consumedetail/manage/getConsumeDetail`;
// 套餐消费
export const menuApplyList = `${requestUrl}/manage/menuApply/list`;
// 套餐消费
// export const queryByIdQueryById = `${requestUrl}/manage/myMenu/queryById`;
export const queryByCode = (code) =>
  `${requestUrl}/manage/myMenu/queryByCode?code=${code}`;
// 订单列表
export const imageOrdersList = `${requestUrl}/manage/order/list`;
// 订单列表详情
export const imageOrdersDetail = (id) =>
  `${requestUrl}/manage/order/queryById?id=${id}`;
// 充值记录详情
export const queryById = (id) => `${requestUrl}/paycenter/queryById?id=${id}`;
// 图片下载
export const imageExport = `/manage/order/export
`;
export const getAllConsumeType = () => "/consumedetail/getAllConsumeType";

export const exportConsumeDetail = `/consumedetail/manage/exportConsumeDetail`;

export const menuApplyExport = `/manage/menuApply/export`;

// 定制套餐新增
export const addMade = `${requestUrl}/manage/menu/made`;
// 定制套餐编辑
export const editMade = `${requestUrl}/manage/menu/made`;
// 定制套餐列表
export const getMadeList = `${requestUrl}/manage/menu/madeList`;
// 定制套餐记录
export const madeRecord = `${requestUrl}/manage/menu/record`;
// 定制套餐删除
export const deleteGrant = (id) =>
  `${requestUrl}/manage/menu/grant/delete?id=${id}`;
// 修改定制套餐
export const grantEdit = `${requestUrl}/manage/menu/grantEdit`;

// 实名认证
export const certificationByPhone = (phone) =>
  `${oauthRequestUrl}/oauth/certificationByPhone?phone=${phone}`;

// 发放
export const grant = `${requestUrl}/manage/menu/grant`;

// 发票查询
export const invoiceQueryByCode = (code) =>
  `${requestUrl}/manage/invoice/queryByCode?code=${code}`;
